export function LogoEyeballSmall() {
	return <span className="icon-new icon-logo-eyeball-color" />;
}

export default LogoEyeballSmall;
